import { Guid } from "../../../types/guid.type";
import { EntityBase, IEntityBaseInfo } from "../../entity/entitybase";

export interface IBusinessUnitQuotationQuestionInfo extends IEntityBaseInfo {
  BusinessUnitUid: Guid;
  QuotationQuestionUid: Guid;
}

export class BusinessUnitQuotationQuestion extends EntityBase {

  BusinessUnitUid: Guid;
  QuotationQuestionUid: Guid;

  constructor(info: IBusinessUnitQuotationQuestionInfo) {
    super(info);

    this.BusinessUnitUid = info.BusinessUnitUid;
    this.QuotationQuestionUid = info.QuotationQuestionUid;
  }
}
